import React from 'react';
import { formatDate } from '../../utils/dateFormatter';

export const PrintLayout = ({ title, documentType, children }) => {
  const today = formatDate(new Date());

  return (
    <div className="print-container bg-white text-black p-8 max-w-4xl mx-auto">
      {/* Header */}
      <div className="print-header text-center mb-6 pb-4 border-b-2 border-gray-800">
        <h1 className="text-2xl font-bold mb-1">CLADAKIS FOR READY MADE GARMENTS</h1>
        <p className="text-sm text-gray-600">Garment Manufacturing & Trading</p>
      </div>

      {/* Document Title */}
      <div className="text-center mb-6">
        <h2 className="text-xl font-semibold uppercase">{documentType}</h2>
        {title && <p className="text-lg mt-1">{title}</p>}
      </div>

      {/* Content */}
      <div className="print-content">
        {children}
      </div>

      {/* Footer */}
      <div className="print-footer mt-8 pt-4 border-t border-gray-300 text-center text-sm text-gray-500">
        <p>Printed on: {today}</p>
      </div>
    </div>
  );
};

export const PrintButton = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className="print-show inline-flex items-center gap-2 px-3 py-1.5 text-sm border rounded-md hover:bg-gray-100 transition-colors"
    >
      {children}
    </button>
  );
};

export const printDocument = (printRef) => {
  if (printRef.current) {
    const printContent = printRef.current.innerHTML;
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print Document</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body {
              font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
              padding: 20px;
              color: #000;
              background: #fff;
            }
            .print-container { max-width: 800px; margin: 0 auto; }
            .print-header { text-align: center; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 2px solid #333; }
            .print-header h1 { font-size: 20pt; font-weight: bold; margin-bottom: 5px; }
            .print-header p { font-size: 10pt; color: #666; }
            .print-table { width: 100%; border-collapse: collapse; margin: 15px 0; }
            .print-table th, .print-table td { border: 1px solid #333; padding: 8px 12px; text-align: left; }
            .print-table th { background-color: #f0f0f0; font-weight: bold; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 20px; }
            .info-item { margin-bottom: 5px; }
            .info-label { font-weight: bold; color: #333; }
            .totals { margin-top: 20px; text-align: right; }
            .totals-row { display: flex; justify-content: flex-end; gap: 20px; margin: 5px 0; }
            .totals-label { font-weight: 500; }
            .totals-value { font-weight: bold; min-width: 100px; }
            .grand-total { font-size: 14pt; border-top: 2px solid #333; padding-top: 10px; margin-top: 10px; }
            .signature-section { margin-top: 60px; display: flex; justify-content: space-between; }
            .signature-line { width: 200px; border-top: 1px solid #333; padding-top: 5px; text-align: center; }
            .print-footer { margin-top: 40px; padding-top: 10px; border-top: 1px solid #ccc; text-align: center; font-size: 9pt; color: #666; }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .font-bold { font-weight: bold; }
            .mb-4 { margin-bottom: 15px; }
            .mb-6 { margin-bottom: 20px; }
            .mt-4 { margin-top: 15px; }
            .uppercase { text-transform: uppercase; }
            .badge { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 10pt; }
            .badge-success { background: #d1fae5; color: #065f46; }
            .badge-warning { background: #fef3c7; color: #92400e; }
            .badge-danger { background: #fee2e2; color: #991b1b; }
          </style>
        </head>
        <body>
          ${printContent}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); }
            }
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  }
};
